import * as PIXI from 'pixi.js-legacy';
import UAParser from 'ua-parser-js';
const uaparser = new UAParser();

if (uaparser.getBrowser().name.toLowerCase().includes('safari')) {
  const SafariReplaceWebpWithJpgPlugin = {
    add() {
      // handle loading SVGZ files as an ArrayBuffer
      PIXI.LoaderResource.setExtensionXhrType(
        'webp', PIXI.LoaderResource.XHR_RESPONSE_TYPE.BUFFER);
      PIXI.LoaderResource.setExtensionLoadType(
        'web', PIXI.LoaderResource.LOAD_TYPE.XHR);
    },
    pre(resource, next) {
      resource.url = resource.url.replace('.webp', '.png');
      next();
    }
  };
  PIXI.Loader.registerPlugin(SafariReplaceWebpWithJpgPlugin);
}
